export default __webpack_public_path__ + "static/media/logoSimple.db14fd1d.png";